export default __webpack_public_path__ + "static/media/ResumeImages.1ceed173.svg";